import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';
import Flexbox from 'flexbox-react';
import DataExplorerService from 'services/DataExplorerService';
import MessageBox from 'components/core/MessageBox';
import { colorLabelBlue, colorTextGrey, colorVeryLightYellow } from 'styles/base';

export default class TransformationParameterForm extends React.Component {
    static propTypes = {
        process: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.boldFont = css`font-weight:bold`;
        this.labelStyle = css`color:${colorLabelBlue}`;
        this.descStyle = css`
            padding: 0 15px 20px 15px;
            color: ${colorTextGrey};
            font-style: italic;
        `;
        this.titleStyle = css`
            font-weight: 700;
            margin-bottom: 10px;
        `;
        this.headingStyle = css`
            height: 70px;
        `;
    }

    renderTitle = () => {
        return '';
    };

    renderDescription = () => {
        return '';
    };

    renderHeading = () => {
        return (
            <Flexbox className={cx('tp-heading', this.headingStyle)} flexDirection={'column'}>
                <div className={cx('tp-title', this.titleStyle)}>{this.renderTitle()}</div>
                <div className={cx('tp-desc', this.descStyle)}>{this.renderDescription()}</div>
            </Flexbox>
        );
    };

    renderExploringDataMessage = () => {
        return (
            <MessageBox includeIcon>
                <p>The data explorer must finish before setting transformation parameters.</p>
            </MessageBox>
        );
    };

    renderForm = () => {
        return '';
    };

    isReady = () => {
        return !DataExplorerService.isDataBeingExplored(this.props.process.name);
    };

    render() {
        const headerStyle = css`
            max-width: 400px;
        `;

        const wrapperStyle = css`
            .data-explorer-page {
                margin-top: -25px;
                .explore-button {
                    margin-top: -30px;
                }
                .data-explorer-message {
                    display: none;
                }
                .input-qc-form, output-qc-form {
                    background-color: transparent;
                }
            }
        `;

        return (
            <Flexbox flexDirection={'column'} className={wrapperStyle}>
                <div className={headerStyle}>
                    {this.renderHeading()}
                </div>
                {this.isReady() ?
                    this.renderForm()
                    :
                    this.renderExploringDataMessage()
                }
            </Flexbox>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/TransformationParameterForm.js